/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {IconIsActive} from '../../../../../../components/IconIsActive'

type Props = {
  value: string
  activeAlert: boolean
  alertObservation: string
}

const CustonCell: FC<Props> = ({value, activeAlert, alertObservation}) => {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        <span role='button' className=' text-hover-danger'>
          {activeAlert && <IconIsActive text={alertObservation} />}
          {value}
        </span>
      </div>
    </div>
  )
}

export {CustonCell}
